// The queue stays app-side; package code reaches the app hook by reference.
import type { ModalId, ModalViewAction } from '@heidi/schema/ml-scribe';

/** Twin of the app hook's close options. */
export interface QueuedModalCloseOptions {
  action?: ModalViewAction;
  increment_count?: boolean;
  hide_forever?: boolean;
  skipPacing?: boolean;
}

/** What the app's `useQueuedModal` returns. */
export interface QueuedModalSubscription {
  isOpen: boolean;
  dismissible: boolean;
  handleClose: () => void;
  onOpenChange: (open: boolean) => void;
  closeWithOptions: (options?: QueuedModalCloseOptions) => void;
}

type QueuedModalImpl = (modalId: ModalId) => QueuedModalSubscription;
let impl: QueuedModalImpl | null = null;

export const configureQueuedModal = (next: QueuedModalImpl): void => {
  impl = next;
};

export function useQueuedModal(modalId: ModalId): QueuedModalSubscription {
  if (!impl) {
    throw new Error(
      '[utils/queued-modal] not configured — the app must load queued-modal-wiring at bootstrap; tests must call configureQueuedModal() first.'
    );
  }
  return impl(modalId);
}
